module.exports = __webpack_public_path__ + "media/images/knockout__pickarrow@3x-651c57944d290d3692135c4787983afd.png";